import { formatFloat } from './number';
import { getTimezoneOffsetInSeconds } from './index';

export function makeChartData(data, chickenTypes, customFormat) {
  if (!data) {
    return [];
  }
  
  const formatter = customFormat || formatFloat;
  const dailyData = {};
  
  for (const restaurant of data) {
    if (restaurant.values) {
      for (const restDay of restaurant.values) {
        const ts = restDay[0];
        const payload = restDay[1];
        
        if (!dailyData[ts]) {
          dailyData[ts] = Array.from({ length: chickenTypes.length }, () => 0);
        }
        
        chickenTypes.forEach((type, index) => {
          const typeValue = payload[type];
          
          if (typeValue) {
            dailyData[ts][index] += typeValue;
          }
        });
      }
    }
  }
  
  return Object.entries(dailyData).map(entry => {
    const [ts, values] = entry;
    const formattedValues = values.map(val => val ? formatter(val) : val);
    
    return [new Date(ts * 1000), ...formattedValues];
  });
}

export function getDistributionDualYChartContent(
  distContent,
  leftYKey = 'value',
  rightYKey = 'share',
) {
  return distContent.map((item) => {
    const distValue = formatFloat(item[leftYKey]);
    const share = formatFloat(item[rightYKey] * 100);
    
    return [item.material, distValue, share];
  });
}

export function getHoldTimePeriods() {
  return [
    {
      title: '≤ 20 Minutes',
      key: '≤ 20 Minutes',
      color: '#009308',
      textShadow: '0 1px 4px rgba(1, 62, 0, 0.95)',
    },
    {
      title: '20-25 Minutes',
      key: '20-25 Minutes',
      color: '#9747FF',
      textShadow: '0 1px 4px rgba(113, 0, 141, 0.90)',
    },
    {
      title: '25-30 Minutes',
      key: '25-30 Minutes',
      color: '#2F80ED',
      textShadow: '0 1px 4px rgba(0, 65, 141, 0.90)',
    },
    {
      title: '30-35 Minutes',
      key: '30-35 Minutes',
      color: '#F4D548',
      textShadow: '0 1px 4px rgba(141, 101, 0, 0.90)',
    },
    {
      title: '35-40 Minutes',
      key: '35-40 Minutes',
      color: '#FF7D00',
      textShadow: '0 1px 4px rgba(141, 76, 0, 0.90)',
    },
    {
      title: '>40 Minutes',
      key: '>40 Minutes',
      color: '#DD0031',
      textShadow: '0 1px 4px rgba(75, 0, 0, 0.85)',
    },
  ];
}
